module.exports = __webpack_public_path__ + "img/vol05_cup01_cover04.cea47604.jpg";